import { useState, useCallback } from 'react';
import { LYFT_RIDE_STATUSES } from '../utils/constants';

export const useMRTableModals = () => {
  const [isPhoneEditOpen, setIsPhoneEditOpen] = useState(false);
  const [openNextAppt, setOpenNextAppt] = useState(false);
  const [openReadAppt, setOpenReadAppt] = useState(false);
  const [openLyftDialog, setOpenLyftDialog] = useState(false);
  const [openLyftStatusDialog, setOpenLyftStatusDialog] = useState(false);
  const [isFirstTimeLyftStatusModalOpen, setIsFirstTimeLyftStatusModalOpen] = useState(false);
  const [openErrorPopUp, setOpenErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [openCanceledRide, setOpenCanceledRide] = useState(false);

  const togglePhoneEdit = () => {
    setIsPhoneEditOpen(!isPhoneEditOpen);
  };

  const onClosePhoneEdit = () => {
    setIsPhoneEditOpen(false);
  }
  
  const onOpenNextApptCalendar = useCallback((rowData) => {
    if(rowData?.NextAppointmentId) {
      setOpenReadAppt(true);
    } else {
      setOpenNextAppt(true);
    }
  },[])

  const onCloseNextAppt = useCallback(() => {
    setOpenNextAppt(false)
  },[])

  const onCloseReadAppt = useCallback(() => {
    setOpenReadAppt(false)
  },[])

  const onOpenLyftStatusDialog = useCallback(() => {
    setOpenLyftStatusDialog(true);
    setIsFirstTimeLyftStatusModalOpen(true);
  },[])

  const onOpenLyftDialog = useCallback((workOrder) => {
    // if WO has a courtesy ride created
    if(workOrder?.CourtesyRidesData && workOrder.CourtesyRidesData[0].status !== LYFT_RIDE_STATUSES.canceled) {
      setOpenLyftStatusDialog(true);
    } else {
      setOpenLyftDialog(true)
    }
  },[])

  const onCloseLyftDialog = useCallback((event, reason) => {
    if (reason && reason === "backdropClick") 
      return;
    setOpenLyftDialog(false)
  }, [])

  const onCloseLyftStatusDialog = useCallback((event, reason) => {
    if (reason && reason === "backdropClick") 
      return;
    setOpenLyftStatusDialog(false)
  }, [])


  const onCloseErrorPopup = () => {
    setOpenErrorPopup(false)
  }

  const onCloseCanceledRide = () => {
    setOpenCanceledRide(false)
  }

  const openRequestRideDialog = () => {
    setOpenLyftDialog(true)
  }

  const onOpenCanceledRideDialog = () => {
    setOpenCanceledRide(true)
  }

  const onCloseDialogsByLyftCancel = () => {
    onCloseLyftDialog();
    onCloseNextAppt();
    onCloseReadAppt();
    onClosePhoneEdit();
    onCloseLyftStatusDialog();
  }

  return {
    isPhoneEditOpen,
    togglePhoneEdit,
    openNextAppt,
    openReadAppt,
    onOpenNextApptCalendar,
    onCloseNextAppt,
    onCloseReadAppt,
    openLyftDialog,
    onOpenLyftStatusDialog,
    openLyftStatusDialog,
    onOpenLyftDialog,
    onCloseLyftDialog,
    onCloseLyftStatusDialog,
    isFirstTimeLyftStatusModalOpen,
    setIsFirstTimeLyftStatusModalOpen,
    openErrorPopUp,
    onCloseErrorPopup,
    setOpenErrorPopup,
    errorMessage,
    setErrorMessage,
    openCanceledRide,
    onCloseCanceledRide,
    onOpenCanceledRideDialog,
    openRequestRideDialog,
    onCloseDialogsByLyftCancel
  };
};
